var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 350,
    viewBox: "0 0 440 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220 350C98.4972 350 -0.000244141 271.65 -0.000244141 175C-0.000244141 78.3502 98.4972 0 220 0C341.503 0 440 78.3502 440 175C440 227.628 410.795 274.831 364.573 306.911C365.644 319.469 370.999 336.458 386.813 348.943C371.543 351.683 342.136 350.258 321.202 330.426C290.906 342.933 256.49 350 220 350Z",
    fill: "#CBD4FA",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBg);
export default __webpack_public_path__ + "static/media/cloud_bg.fec46e06a9482eabd322ba604bc8b917.svg";
export { ForwardRef as ReactComponent };